<template>
  <div class="dealer_suite_wrap">
    <div class="left_box">
      <el-menu :default-active="currentDealer" class="el-menu-vertical-demo" @select="changeMenu">
        <el-menu-item :index="item.id.toString()" :key="item.id" v-for="item in dealerList">
          <span slot="title">{{item.bussinessName}}</span>
        </el-menu-item>
      </el-menu>
    </div>
    <div class="right_box">
      <div class="header">
        <el-button size="medium" type="primary" @click="showAllSuiteBox" v-if="isShowByPermission('/wyms/businessSuite/updateBussinessSuite')">编辑</el-button>
      </div>
      <div class="dealer_suite_content" :style="`height: ${windowHeight - 160}px;`">
        <div class="dealer_suite_list" v-if="dataList && dataList.length">
          <div class="suite_line_box" :key="item.suiteGroups" v-for="item in dataList">
            <div class="suite_title">{{suiteGroupList[item.suiteGroups - 1] || '其他'}}</div>
            <div class="suite_box">
              <div class="suite_item" :key="suiteIndex" v-for="(suiteItem, suiteIndex) in item.suiteList">
                <img class="suite_logo_img" :src="suiteItem.logoUrl">
                <div class="suite_title_wrap">
                  <h2>{{suiteItem.name}}</h2>
                  <div class="suite_tag">{{suiteTypeList[suiteItem.suiteType - 1] || '其他'}}</div>
                  <div class="operation_wrap">
                    <span @click="toSuiteInfo(suiteItem.id)">查看</span>
                    <span @click="toInstallSuite(suiteItem.id)">安装</span>
                  </div>
                </div>
                <div class="build_status has_send" v-if="suiteItem.authType === 0">已发布</div>
                <div class="build_status" v-else>测试中</div>
              </div>
            </div>
          </div>
        </div>
        <div class="no_msg_box" v-else>
          <img src="https://cdnfile-10043692.file.myqcloud.com/class_brand/gridClasscard/nodata/elastic-nodata2.png"
               alt="">
          <div>暂无套件</div>
        </div>
      </div>
    </div>

    <el-dialog title="请选择可安装的套件" :visible.sync="isShowAllSuiteList" :close-on-press-escape='false' width="70%"
               :lock-scroll="false" :close-on-click-modal='false' :modal-append-to-body='false' :show-close="false">
      <div class="all_suite_box" :style="`height: ${windowHeight - 400}px;`">
        <div class="suite_level_box" :key="suiteIndex" v-for="(suiteItem, suiteIndex) in allSuiteList">
          <div class="top_text">{{suiteGroupList[suiteItem.suiteGroups - 1] || '其他'}}</div>
          <div class="suite_box_wrap">
            <div class="suite_box_item" :key="index" v-for="(item, index) in suiteItem.suiteList" @click.stop="addNewSuite(item.id)">
              <img :src="item.logoUrl" :alt="item.name">
              <div>{{item.name}}</div>
              <i class="el-icon-success"></i>
              <i class="el-icon-success select-icon" v-show="isShowSuiteIcon(item.id)"></i>
            </div>
          </div>
        </div>
        <div class="no_msg_box" v-if="!allSuiteList || !allSuiteList.length">
          <img src="https://cdnfile-10043692.file.myqcloud.com/class_brand/gridClasscard/nodata/elastic-nodata2.png" alt="">
          <div>暂无套件</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelSuite">取 消</el-button>
        <el-button type="primary" @click="changeSuite">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
    import {isShowByPermission} from "@/utils/utils";

    import windowResize from '@/mixins/windowResize';
  import AddressBook from '@/components/AddressBook/indexExpand';
  import {querySuiteList, getAllDealerManageList, queryBussinessSuiteList, updateBussinessSuite} from '@/api/dealerManage';
  import {suiteInstall} from '@/api/suiteSystem'

  export default {
    name: "dealerSuiteIndex",
    components: {
      AddressBook
    },
    data() {
      return {
        isShowAllSuiteList: false,
        allSuiteList: [],
        suiteGroupList: ['通讯录套件', '基础套件', '独立应用', '行业应用'],
        suiteTypeList: ['应用套件', '通讯录套件', '普通应用', '通讯录应用', '其他', '家校应用'],
        showSuiteIds: [],
        currentDealerSuiteList: [],
        dealerList: [],
        currentDealer: null,
        dataList: []
      }
    },
    mixins: [windowResize],
    watch: {
      currentDealer() {
        this.queryBussinessSuiteList();
      }
    },
    created() {
      this.getAllDealerManageList();
      this.querySuiteList();
    },
    methods: {
        isShowByPermission,
      goBack() {
        this.$router.go(-1);
      },
      // 获取经销商套件
      changeMenu(val) {
        this.currentDealer = val;
      },
      querySuiteList() {
        querySuiteList().then(data => {
          if (data) {
            let suiteGroupList = [];
            data.forEach((item) => {
              if (suiteGroupList.indexOf(item.suiteGroups) > -1) {
                const groupIndex = suiteGroupList.indexOf(item.suiteGroups);
                this.allSuiteList[groupIndex].suiteList.push(item)
              } else {
                suiteGroupList.push(item.suiteGroups);
                this.allSuiteList.push({
                  suiteGroups: item.suiteGroups,
                  suiteList: [item]
                })
              }
            })
          }
        })
      },
      getAllDealerManageList() {
        getAllDealerManageList().then(data => {
          this.dealerList = data;
          if (data && data.length) {
            this.currentDealer = data[0].id.toString();
          }
        })
      },
      queryBussinessSuiteList() {
        queryBussinessSuiteList({businessId: this.currentDealer}).then(data => {
          this.currentDealerSuiteList = data || [];
          this.dataList = [];
          if (data) {
            let suiteGroupList = [];
            data.forEach((item) => {
              if (suiteGroupList.indexOf(item.suiteGroups) > -1) {
                const groupIndex = suiteGroupList.indexOf(item.suiteGroups);
                this.dataList[groupIndex].suiteList.push(item)
              } else {
                suiteGroupList.push(item.suiteGroups);
                this.dataList.push({
                  suiteGroups: item.suiteGroups,
                  suiteList: [item]
                })
              }
            })
          }
        })
      },
      // 编辑经销商套件
      showAllSuiteBox() {
        this.showSuiteIds = [];
        this.currentDealerSuiteList.forEach((item) => {
          this.showSuiteIds.push(item.id);
        });
        this.isShowAllSuiteList = true;
      },
      cancelSuite() {
        this.isShowAllSuiteList = false;
        this.showSuiteIds = [];
      },
      addNewSuite(suiteId) {
        if (this.showSuiteIds.indexOf(Number(suiteId)) < 0) {
          this.showSuiteIds.push(Number(suiteId));
        } else {
          this.showSuiteIds.splice(this.showSuiteIds.indexOf(Number(suiteId)), 1);
        }
      },
      isShowSuiteIcon(suiteId) {
        return this.showSuiteIds.indexOf(suiteId) > -1;
      },
      changeSuite() {
        if (!this.showSuiteIds.length) {
          this.$message.warning('请选择可安装的套件！');
          return;
        }
        this.isShowAllSuiteList = false;
        updateBussinessSuite({businessId: this.currentDealer, suiteIds: this.showSuiteIds.toString()}).then(data => {
          this.queryBussinessSuiteList();
        })
      },
      toSuiteInfo(suiteId) {
        this.$router.push({path: 'dealerSuiteInfo', query: {suiteId: suiteId}})
      },
      toInstallSuite(suiteId) {
        suiteInstall({id: suiteId}).then(data => {
          window.open(data, '_blank');
        })
      }
    }
  }
</script>

<style>
  .dealer_suite_wrap .el-menu-item {
    height: 36px;
    line-height: 36px;
  }

  .dealer_suite_wrap .el-menu {
    border-right-width: 0;
  }
</style>
<style lang="scss" scoped>
  @import './../../../styles/mixin';

  .dealer_suite_wrap {
    height: 100%;
    padding: 12px;
    display: flex;
    box-sizing: border-box;

    .left_box {
      width: 180px;
      height: 100%;
      border-right: 1px solid #eee;
      @include scrollBar;
    }

    .right_box {
      flex: 1;
      overflow: hidden;

      .header {
        padding-bottom: 10px;
        padding-left: 10px;
        border-bottom: 1px solid #eee;
      }

      .dealer_suite_list{
        .suite_line_box{
          overflow: hidden;
          .suite_title{
            height: 20px;
            line-height: 20px;
            margin-top: 10px;
            margin-left: 15px;
            padding-left: 8px;
            border-left: 4px solid #409EFF;
            font-weight: bold;
          }
          .suite_box{
            padding-bottom: 20px;
            overflow: hidden;
            .suite_item{
              @include clearfix;
              position: relative;
              height: 120px;
              margin-top: 20px;
              margin-left: 20px;
              padding: 10px;
              box-sizing: border-box;
              float: left;
              overflow: hidden;
              border-radius: 5px;
              box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
              transition: all .2s linear;

              &:hover{
                box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
                transform: translate3d(0, -2px, 0);
              }

              .suite_logo_img{
                float: left;
                width: 80px;
                height: 80px;
                margin: 10px 15px 10px 5px;
                border-radius: 4px;
              }
              .suite_title_wrap{
                float: left;
                width: 140px;
                height: 90px;
                h2{
                  font-size: 16px;
                  font-weight: bold;
                  width: 100%;
                  max-height: 40px;
                  line-height: 20px;
                  margin: 10px 0;
                  word-wrap: break-word;
                  word-break: break-all;
                  overflow: hidden;
                }
                .suite_tag {
                  padding: 5px 15px;
                  background: #e5e5e5;
                  text-align: center;
                  display: inline-block;
                  line-height: 20px;
                }
                .operation_wrap {
                  font-size: 16px;
                  margin-top: 10px;
                  span{
                    margin-right: 5px;
                    color: #409EFF;
                    cursor: pointer;
                  }
                }
              }
              .build_status {
                position: absolute;
                top: 10px;
                right: -20px;
                width: 80px;
                height: 20px;
                font-size: 14px;
                line-height: 20px;
                text-align: center;
                color: #fff;
                background: #409eff;
                transform: rotate(45deg);
              }
              .has_send{
                background: #f56c6c;
              }
            }
          }
        }
      }

      .dealer_suite_content {
        padding-top: 10px;
        padding-left: 10px;
        @include scrollBar;
      }
    }

    .all_suite_box{
      @include scrollBar;
      .suite_level_box{
        .top_text{
          line-height: 24px;
          margin-bottom: 15px;
          padding-left: 14px;
          font-size: 16px;
          border-left: 4px solid #409EFF;
        }
        .suite_box_wrap{
          @include clearfix;

          .suite_box_item{
            position: relative;
            width: 120px;
            float: left;
            margin-bottom: 20px;
            margin-left: 15px;
            cursor: pointer;
            img{
              display: block;
              width: 80px;
              height: 80px;
              margin: 10px auto;
              border-radius: 6px;
            }
            div{
              height: 20px;
              line-height: 20px;
              text-align: center;
              overflow: hidden;
            }
            i{
              position: absolute;
              top: 0;
              right: 10px;
              font-size: 26px;
              color: #efefef;
              background: #fff;
              border-radius: 50%;
            }
            .select-icon{
              color: #409eff;
            }
          }
        }
      }
    }

    .no_msg_box {
      text-align: center;
      font-size: 15px;
      color: #999;
      overflow: hidden;

      img {
        display: block;
        margin: 30px auto 0;
      }

      div {
        height: 20px;
        line-height: 20px;
        margin-top: -40px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/dealerManage/dealerSuite/dealerSuiteIndex.vue